// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__15qnL","container":"styles_container__1YK5y","title":"styles_title__2y5pB","wrapper":"styles_wrapper__1KJuO","answer":"styles_answer__1Nebu"};